import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu";
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";

import {
  OverlayTrigger,
  Tooltip,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Modal,
  Nav,
  Table,
  Navbar,
} from "react-bootstrap";

export class LifeStyleAquaAuthenticator extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      authenticator: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
    };
  }
  GetLifeStyleAquaAuthenticator = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetLifeStyleAquaAuthenticatorList/" +
        this.context.storeId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ authenticator: data }, () => {
            this.setState({ reload: false }, () => {
              this.setState({ reload: true });
            });
          });
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnSaved = () => {
    this.OnRefreshButtonClick();
  };
  OnDeleted = () => {
    this.OnRefreshButtonClick();
  };

  OnRefreshButtonClick = () => {
    this.setState({ authenticator: [] }, () => {
      this.GetLifeStyleAquaAuthenticator();
    });
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };

  OnUpdated = (indexno) => {
    this.OnRefreshButtonClick();
  };

  addModalClose = () => {
    this.setState({ addModalShow: false }, () => {});
    this.OnRefreshButtonClick();
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    if (this.state.authenticator.length == 0)
      this.GetLifeStyleAquaAuthenticator();
  };

  render() {
    return (
      <>
        <div className="Container-fluid p-0 ">
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
            <h3> Authenticator DB &nbsp;</h3>
            <Navbar.Collapse className="justify-content-end mx-0 ">
              <Nav>
                <ButtonToolbar className="text-end align-middle">
                  <Button
                    className="mainthemecolor"
                    // onClick={() => this.handleAddSupplier()}
                    onClick={() => this.setState({ addModalShow: true })}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      fill="currentColor"
                      class="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    Add
                  </Button>
                  &nbsp;
                  <Button
                    className="mainthemecolor"
                    size=""
                    onClick={() => this.OnRefreshButtonClick()}
                  >
                    <BiRefresh size="26"></BiRefresh>
                    Refresh
                  </Button>
                  &nbsp;
                  {this.state.addModalShow === true ? (
                    <LifeStyleAquaAuthenticatorAddOrEditModal
                      show={this.state.addModalShow}
                      Type="Add"
                      onHide={this.addModalClose}
                    />
                  ) : null}
                </ButtonToolbar>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <div>
            <Table border striped className="px-0 bg-white ">
              <thead className="">
                <tr className="text-start text-black bg-white border">
                  <th>#</th>
                  <th width="10%">Created</th>
                  <th width="20%">Tag Id</th>
                  <th width="10%">Fish Category</th>
                  <th width="10%">Farm Name</th>
                  {/* <th width="10%">CustomerName</th> */}
                  <th width="20%">City</th>
                  <th width="10%">Quality (1-5)</th>
                  <th width="10%" className="text-center">
                    Options
                  </th>
                </tr>
              </thead>
              <tbody className="text-primary border">
                {this.state.authenticator
                  .sort((a, b) => (a.created > b.created ? 1 : -1))
                  .map((authenticator, i) =>
                    this.state.reload === true ? (
                      <EditLifeStyleAquaAuthenticator
                        index={i}
                        authenticator={authenticator}
                        OnDeleted={this.OnDeleted}
                      ></EditLifeStyleAquaAuthenticator>
                    ) : null
                  )}
              </tbody>
            </Table>
          </div>
        </div>
      </>
    );
  }
}

export class EditLifeStyleAquaAuthenticator extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      authenticator: "",
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      editModalShow: false,
    };
  }

  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnDelete = () => {
    if (this.state.authenticator.id == undefined) {
      this.ShowMessagBox(
        "Information",
        "This is invalid row which can't be deleted. Press Refresh!"
      );
      return;
    }

    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "StoreManager/DeleteLifeStyleAquaAuthenticator/" +
        this.state.authenticator.id,
      requestOptions
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          alert(
            "Not deleted. This Supplier may be associated with few Products. First disassociate this authenticator from the Products and then try!"
          );
          return;
        }
        this.HideLoadSpinner();
        this.ShowMessagBox(
          "Status",
          "Deleted Successfully. Click Refresh Button to see the changes!"
        );
        this.props.OnDeleted();
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("OnDelete Failed" + error);
      });
  };

  componentDidMount = () => {
    this.setState({ authenticator: this.props.authenticator });
  };
  OnEditButtonClick = () => {
    this.setState({ editModalShow: true }, () => {});
  };

  editModalClose = () => {
    this.setState({ editModalShow: false }, () => {});
  };

  render() {
    return (
      <>
        {this.state.editModalShow === true ? (
          <LifeStyleAquaAuthenticatorAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.editModalClose}
            authenticator={this.state.authenticator}
            Type="Edit"
          />
        ) : (
          ""
        )}
        {this.state.loadSpinnerOpen === true ? (
          <LoadSpinner open="true"></LoadSpinner>
        ) : (
          ""
        )}
        <tr
          className="text-center align-middle text-secondary bg-white mx-5"
          style={{ fontSize: "12px" }}
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          <td className="text-start ">{this.props.index + 1}</td>
          <td className="text-start ">
            {this.context.GetInDateFormat(
              new Date(this.state.authenticator.created)
            )}
          </td>
          <td className="text-start ">{this.state.authenticator.chipCode}</td>
          <td className="text-start ">
            {this.state.authenticator.fishVariety}
          </td>
          <td className="text-start ">{this.state.authenticator.farmName}</td>
          {/* <td className="text-start ">
            {this.state.authenticator.customerName}
          </td> */}
          <td className="text-start ">
            {this.state.authenticator.customerAddress}
          </td>
          <td className="text-start ">
            {this.state.authenticator.customerMobileNo}
          </td>

          <td className="col-md-2 text-end align-middle ">
            <div class="btn-group">
              <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                <Button
                  variant="warning"
                  onClick={(e) => {
                    this.OnEditButtonClick(e);
                  }}
                >
                  <BsFillPencilFill size="20" />
                </Button>
              </OverlayTrigger>

              <OverlayTrigger
                overlay={
                  <Tooltip>
                    Warning! This will delete this Brand Row and associated
                    Products as well.
                  </Tooltip>
                }
              >
                <Button
                  className="mx-1 "
                  variant="danger"
                  onClick={(e) => {
                    if (window.confirm("Are you sure you want to Delete?")) {
                      this.OnDelete(e);
                    }
                  }}
                >
                  X
                </Button>
              </OverlayTrigger>
            </div>
          </td>
        </tr>
      </>
    );
  }
}

export class LifeStyleAquaAuthenticatorAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {
      authenticator: {},
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
    };
  }

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide();
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };

  AddOrUpdateLifeStyleAquaAuthenticator = () => {
    this.ShowLoadSpinner();

    var tmpSupplier = this.state.authenticator;
    if (this.props.Type == "Edit") {
      tmpSupplier = this.props.authenticator;
    } else {
      tmpSupplier.storeId = this.context.storeId;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(tmpSupplier),
    };

    fetch(
      process.env.REACT_APP_API +
        "StoreManager/AddOrUpdateLifeStyleAquaAuthenticator/",
      requestOptions
    )
      .then((res) => {
        if (res.status == 200) {
          this.HideLoadSpinner();
          this.props.onHide();
          return;
        }
        this.HideLoadSpinner();
        alert("This Supplier is already exist. try again!");
        return;
      })
      .catch((error) => {
        this.HideLoadSpinner();
        alert("Exception. Received an Exception. Try after sometime !" + error);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.AddOrUpdateLifeStyleAquaAuthenticator();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    switch (name.trim()) {
      case "chipCode":
        this.state.authenticator.chipCode = value;
        break;
      case "fishVariety":
        this.state.authenticator.fishVariety = value;
        break;
      case "farmName":
        this.state.authenticator.farmName = value;
        break;
      // case "customerName":
      //   this.state.authenticator.customerName = value;
      //   break;
      case "customerAddress":
        this.state.authenticator.customerAddress = value;
        break;
      case "customerMobileNo":
        this.state.authenticator.customerMobileNo = value;
        break;
    }
    this.setState({ authenticator: this.state.authenticator });
  };

  componentDidMount() {
    if (this.props.Type == "Edit") {
      this.setState({ authenticator: this.props.authenticator });
    }
  }

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="SupplierModal"
        >
          {this.state.msgboxOpen === true ? (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          ) : (
            ""
          )}
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type == "Edit"
                  ? "Edit authenticator"
                  : "Add authenticator"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              <Row
                className="m-2 p-2 bg-light border"
                style={{ fontSize: "12pt" }}
              >
                <Col md={12}>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      TAG ID
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="chipCode"
                        maxlength="99"
                        value={this.state.authenticator.chipCode}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Fish Category
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="fishVariety"
                        maxlength="99"
                        value={this.state.authenticator.fishVariety}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Farm Name
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="farmName"
                        maxlength="99"
                        value={this.state.authenticator.farmName}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  {/* <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Customer Name
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="customerName"
                        maxlength="99"
                        value={this.state.authenticator.customerName}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group> */}
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      City
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="customerAddress"
                        maxlength="99"
                        value={this.state.authenticator.customerAddress}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row} className="mb-3 " controlId="">
                    <Form.Label column sm="3">
                      Quality (1-5)
                    </Form.Label>
                    <Col sm="9">
                      <Form.Control
                        type="text"
                        name="customerMobileNo"
                        maxlength="1"
                        value={this.state.authenticator.customerMobileNo}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={(e) => this.handleInputChange(e)}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}
